module.exports = __webpack_public_path__ + "img/slide_p7.c1f898c9.png";